<script>
  import LazyImage from "../molecules/LazyImage.svelte";
  import { onMount } from "svelte";
  import * as PropTypes from "prop-types";
  export let src;
  export let width = "w-32";
  export let height = "h-32";
  export let lazyload = false;
  export let bdrs = "rounded-[50%]";
  export let flexShrink = "shrink-0";
  const { checkPropTypes, string, bool } = PropTypes;
  const propTypes = {
    src: string,
    width: string,
    height: string,
    lazyload: bool,
    bdrs: string,
  };
  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "Avatar");
  });
</script>

<div
  class={`${width} ${height} ${bdrs} overflow-hidden ${flexShrink}`}
  data-testid="avatar"
>
  <LazyImage {src} disabled={!lazyload} objectFitClass={"object-contain"} />
</div>
